/** Small role-aware default landing for /app/crm.
 * Customer + logistics roles don't have a Dashboard view — they land on Tickets.
 */
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import CrmDashboard from "@/pages/crm/CrmDashboard";

const STAFF_WITH_DASHBOARD = ["admin", "support", "sales", "marketing", "b2b_admin"];

export default function CrmIndex() {
  const { user } = useAuth();
  if (!STAFF_WITH_DASHBOARD.includes(user?.role)) {
    return <Navigate to="/app/crm/tickets" replace />;
  }
  return <CrmDashboard />;
}
